
export const useMobile = () => {
  return window.innerWidth <= 800;
};

export const useTabletView = () => {
  return window.innerWidth <= 992;
};